export const config = {
  mobuleBaseUrl: "https://test.partners.casinomobule.com",
  partnerAlias: "amolebet",
  defaultCurrency: "KES",
  defaultLang: "en",
};

export const GameModes = {
  DEMO: "demo",
  REAL: "real",
  FREEROUND: "freeround",
};

const hostname = window.location.hostname;

// Dynamic URLs based on hostname
let APP_URL = "https://dev.amolebet.com";
let API_URL = "https://apidev.amolebet.com/";

if (hostname === "amolebet.com" || hostname === "www.amolebet.com") {
  APP_URL = "https://amolebet.com";
  API_URL = "https://api.amolebet.com/";
}

export const APP_CONFIG = {
  APP_NAME: "Amolebet",
  APP_VERSION: "1.0.0",
  APP_BUILD: "1",
  APP_ENV: hostname.includes("dev") ? "development" : "production",
  APP_URL,
  API_URL,
  CURRENCY: "ETB",
  PROVIDERS_WITHOUT_DEMO: ["aviator", "pragmaticlive"],
};
